
import { ArticleData } from "./types";
import { harmfulContentDetection } from "./harmful-content-detection";
import { YoutubeRecommendation } from "./youtube";
import { adsRanking } from "./ads-ranking";

// Import or define all system design articles here
export const systemDesignArticles: ArticleData[] = [
  harmfulContentDetection,
  YoutubeRecommendation,
  adsRanking
];
